import 'wafir'

import * as Sentry from '@sentry/react'
import { Toaster } from 'react-hot-toast'

import { AuthProvider } from '@/contexts/auth'
import { BreadcrumbsProvider } from '@/contexts/breadcrumbs'
import { DownloadedFilesProvider } from '@/contexts/downloadedFiles'
import { ReportIssueProvider } from '@/contexts/reportIssue'
import { SelectedAppProvider } from '@/contexts/selectedApp'
import { WorkQueueProvider } from '@/contexts/workQueue'
import { WorkspaceProvider } from '@/contexts/workspace'
import ErrorPage from '@/pages/ErrorPage'
import Routes from '@/routes'

import { ThemeProvider } from './components/theme-provider'
import { composeProviders } from './utils/composeProviders'

declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace JSX {
		interface IntrinsicElements {
			'wafir-widget': React.DetailedHTMLProps<
				React.HTMLAttributes<HTMLElement> & {
					installationId?: string
					owner?: string
					repo?: string
					configUrl?: string
				},
				HTMLElement
			>
		}
	}
}

const Providers = composeProviders(
	ThemeProvider,
	AuthProvider,
	WorkspaceProvider,
	SelectedAppProvider,
	WorkQueueProvider,
	ReportIssueProvider,
	DownloadedFilesProvider,
	BreadcrumbsProvider
)

const App = (): JSX.Element => (
	<Providers>
		<Sentry.ErrorBoundary fallback={<ErrorPage />} showDialog>
			<Toaster />
			<Routes />
			<wafir-widget config-url="/wafir.yaml" />
		</Sentry.ErrorBoundary>
	</Providers>
)

export default App
